<template>
  <div>
    <div v-for="accountInfo in latestPayments"
         :key="accountInfo.name"
         class="mb-2">
      <div class="d-flex justify-content-between">
        <div class="font-weight-bolder">{{ accountInfo.account.name }}</div>
        <div :class="{'text-success': accountInfo.account.balance >= 0,
                      'text-danger': accountInfo.account.balance < 0}">
          {{ accountInfo.account.balance | price }}
        </div>
      </div>
      <div>
        <div class="list-group">
          <div v-for="payment in accountInfo.payments"
               :key="payment.id"
               class="list-group-item p-1">
            <div class="small-date">{{ payment.transactionDate | date }}</div>
            <div class="d-flex justify-content-between">
              <div class="small">{{ payment.description }}</div>
              <div class="small"
                   :class="{'text-success': payment.type === 'Deposit',
                          'text-danger':payment.type === 'Withdrawal'}">
                <span v-if="payment.type==='Withdrawal'">-</span>{{ payment.amount | price }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    latestPayments: Array
  }
}
</script>

<style>
.small-date{
  font-size: x-small;
  color: var(--tuscany);
}
</style>